import React, { PureComponent, createRef } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Checkbox, FormControlLabel, Button as MuiButton } from '@material-ui/core'
import OnEvent from 'react-onevent'

// actions

import {
  login,
  switchApp,
  renewSession,
  showSessionTimeoutModal,
  reviewCompanyAgreement,
} from '../actions/auth'
import { isLoggedIn, logOut } from '../utils/api'
import { openErrorMessage } from '../actions/message'
// local files

import ModifiedTextInput from '../components/common/ModifiedTextInput'
import ContainerWithTitle from '../containers/HOC/ContainerWithTitle'
import SideCoverHOC from './SideCover'
import qs from 'query-string'
import { appTargets } from '../utils/constants'
import validateInput from '../utils/validations/Login'
import moment from 'moment'

import DocusignModal from '../components/Modal/DocusignModal'
import DocusignNotificationModal from '../components/Modal/DocusignNotificationModal'
import { saveCompanyAgreement } from '../actions/company'
import NoAccess from './NoAccess'
import { redirectToBlazeInsights } from '../actions/insights'
import Hotjar from '@hotjar/browser'
import { initHubSpot } from '../utils/crm'
import { validateFeatureBranchUrl } from '../utils/validateFeatureBranch'
import { identifySentryUser } from '../sentry'
import { identifyUserpilotUser } from '../userpilotClient'
import PasswordInput from '../components/common/PasswordInput'
import { DashboardNavigation } from './DashboardNavigation/DashboardNavigation'
import styled from 'styled-components'

class Login extends PureComponent {
  state = {
    email: '',
    password: '',
    loading: false,
    errors: {},
    showDocusignModal: false,
    docuRes: {},
    showNoAccess: false,
    redirectApp: null,
    fbUrl: null,
    showPassword: false,
  }

  docusignNotificationModal = createRef()

  timeout = null

  componentDidMount() {
    const searchParams = window.location.search
    const queryParams = qs.parse(searchParams)
    const { token, current, clientUserId, email, password, userCompanyId, fbUrl } = queryParams
    const { match = {} } = this.props
    const { app } = match.params || {}
    this.setState({ redirectApp: app, fbUrl: validateFeatureBranchUrl(fbUrl) ? fbUrl : null })

    if (!token) {
      initHubSpot()
    }

    if (token && !isLoggedIn()) {
      this.props
        .dispatch(renewSession({ Authorization: `Token ${token.split(' ').join('+')}` }))
        .then((res) => {
          let { employee = {}, assignedShop = {}, company = {} } = res

          this.props.dispatch(reviewCompanyAgreement(employee.email, '')).then((docuRes) => {
            if (docuRes) {
              if (!docuRes.timeout) {
                this.onContinueRenewSession(employee, company, assignedShop, res, current)
              } else {
                logOut()
                this.props.history.push(`/`)
              }
            } else {
              this.onContinueRenewSession(employee, company, assignedShop, res, current)
            }
          })
        })
    }

    if (clientUserId && email && password && userCompanyId) {
      logOut()
      this.props.history.push(`/`)

      this.props.dispatch(reviewCompanyAgreement(email, password)).then((docuRes) => {
        if (docuRes) {
          this.setState({
            showDocusignModal: true,
            docuRes: docuRes,
            email: email,
            password: password,
          })
        }
      })
    }

    if (queryParams.return) {
      window.localStorage.setItem('returnUrl', queryParams.return)
    } else {
      window.localStorage.removeItem('returnUrl')
    }
  }

  handleClickShowPassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }))
  }

  handleMouseDownPassword = (event) => {
    // Prevents the default action (focus state from being triggered)
    event.preventDefault()
  }

  onContinueRenewSession = (employee, company, assignedShop, res, current) => {
    window.Appcues &&
      window.Appcues.identify(employee.id, {
        first_name: employee.firstName,
        last_name: employee.lastName,
        email: employee.email,
        created_date_user: employee.created,
        company: company.name,
        plan_type: 'trial',
        plan_tier: 'enterprise',
        user_role: employee.role && employee.role.name,
        product_type: assignedShop && assignedShop.appTarget,
        location: employee.address && employee.address.state,
      })
    window.localStorage.setItem('returnShopId', res.assignedShop && res.assignedShop.id)
    this.props.history.push(`/${current ? 'settings/shop' : 'switch'}`)
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  onSubmit = () => {
    const { email, password } = this.state

    this.setState({
      loading: true,
    })

    if (this.isValid()) {
      // Check ClickWrap Agreement
      this.props.dispatch(reviewCompanyAgreement(email, password)).then((docuRes) => {
        if (docuRes) {
          this.setState({
            loading: false,
            docuRes: docuRes,
          })

          if (docuRes.timeout) {
            if (docuRes.admin) {
              this.setState({ showNoAccess: true })
            } else {
              this.docusignNotificationModal.current.handleClickOpen()
            }
          } else {
            if (docuRes.admin) {
              this.setState({ showDocusignModal: true })
            } else {
              this.onDocusignContinue(false)
            }
          }
        } else {
          this.onDocusignContinue(false)
        }
      })
    }
  }

  onDocusignAccept = (agreement) => {
    this.setState({ showDocusignModal: false })
    if (agreement.status == 'agreed') {
      this.props
        .dispatch(saveCompanyAgreement(this.state.docuRes.userId, agreement.clickwrapId))
        .then((res) => {
          this.onDocusignContinue(true)
        })
    }
  }

  onDocusignDecline = (agreement) => {
    this.setState({ showDocusignModal: false })
    if (this.state.docuRes.timeout) {
      this.setState({ showNoAccess: true })
    } else {
      this.onDocusignContinue(false)
    }
  }

  onDocusignContinue = (reload) => {
    const { email, password, redirectApp } = this.state

    const body = {
      email: email,
      password: password,
      appTarget: 'AuthenticationApp',
    }

    this.props
      .dispatch(login(body))
      .then((res) => {
        let { employee = {}, assignedShop = {}, company = {} } = res
        Hotjar.identify(employee.id, {
          first_name: employee.firstName,
          last_name: employee.lastName,
          email: employee.email,
        })

        window.Appcues &&
          window.Appcues.identify(employee.id, {
            first_name: employee.firstName,
            last_name: employee.lastName,
            email: employee.email,
            created_date_user: employee.created,
            company: company.name,
            plan_type: 'trial',
            plan_tier: 'enterprise',
            user_role: employee.role && employee.role.name,
            product_type: assignedShop && assignedShop.appTarget,
            location: employee.address && employee.address.state,
          })

        identifySentryUser({ email: employee.email })

        let host = ''
        this.setState({ loading: false })

        const { authReducer } = this.props
        const { session = {} } = authReducer
        const { employeeShops = [] } = session

        const appTargetShops = []

        identifyUserpilotUser(session)
        Object.keys(appTargets).forEach((target) => {
          const shop = employeeShops.find((emp) => emp.appTarget === target)
          if (shop) {
            appTargetShops.push(shop)
          }
        })

        /* const hasDistribution = employeeShops.find(emp => emp.appTarget === 'Distribution') || false;
            const hasRetail = employeeShops.find(emp => emp.appTarget === 'Retail') || false;
            const hasGrow = employeeShops.find(emp => emp.appTarget === 'Grow') || false; */
        const { fbUrl } = this.state
        if (appTargetShops.length === 1) {
          const shop = appTargetShops[0]

          host = fbUrl || appTargets[shop.appTarget]
          if (shop.appTarget === 'Grow') {
            /* this.props.dispatch(switchApp({ appName: shop.appTarget, shopId: shop.id, growAppType : 'Sales' }))
                    .then(res => {
                        window.location.href = `${host}/login?token=${res.accessToken}&shop=${shop.id}`;
                        return;
                    })
                    .catch(err => {
                        console.log(err);
                    }); */
            if (reload) {
              window.location.reload()
            }
          } else {
            this.props
              .dispatch(switchApp({ appName: shop.appTarget, shopId: shop.id }))
              .then((res) => {
                window.location.href = `${host}/login?token=${res.accessToken}&shop=${shop.id}`
                return
              })
              .catch((err) => {
                console.log(err)
              })
          }
        } else {
          if (reload) {
            window.location.reload()
          }
          if (fbUrl && appTargetShops.length > 0) {
            const shop = appTargetShops[0]
            window.location.href = `${fbUrl}/login?token=${res.accessToken}&shop=${shop.id}`
            return
          }
        }

        const { expirationTime } = session || {}

        const exp = expirationTime - moment().valueOf() - 60 * 10000
        localStorage.setItem('time', 1200000)
        this.timeout = setTimeout(() => {
          if (isLoggedIn()) {
            this.props.dispatch(showSessionTimeoutModal(true))
          } else if (this.timeout) {
            clearTimeout(this.timeout)
          }
        }, exp)

        //Redirect app by query param
        if (redirectApp == 'INSIGHTS') {
          this.props
            .dispatch(redirectToBlazeInsights())
            .then((url) => {
              if (url != null) {
                window.location.href = url
                return
              }
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.props.history.push('/switch')
        }
      })
      .catch((err) =>
        this.setState({
          loading: false,
        }),
      )
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  isValid = () => {
    const { errors, isValid } = validateInput({
      email: this.state.email,
      password: this.state.password,
    })

    if (!isValid) this.setState({ errors })

    return isValid
  }

  render() {
    const { email, password, errors, showDocusignModal, docuRes, showNoAccess } = this.state
    return (
      <Grid className="rightBlockLogin" item xs={11} sm={7} md={11} lg={7}>
        <OnEvent enter={this.onSubmit}>
          {showNoAccess ? (
            <NoAccess {...this.props} docuRes={docuRes} />
          ) : (
            <div>
              <DashboardNavigation />
              <ModifiedTextInput
                id="name"
                placeholder="Email"
                margin="normal"
                className="margin-top-medium"
                onChange={this.onChange}
                value={email}
                name="email"
                error={errors.email}
                helperText={errors.email}
                data-cy="input-email"
              />
              <PasswordInput
                handlePassword={this.onChange}
                password={password}
                error={errors.password}
              />
              <div className="vertical-middle margin-top-small">
                <FormControlLabel control={<Checkbox value="checkedA" />} label="Remember Me" />
                <Link className="align-auto-right black-link" to="/reset">
                  Forgot Password?
                </Link>
              </div>
              <div style={{ paddingTop: '30px ', display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  data-cy="btn-login"
                  onClick={this.onSubmit}
                  color={'primary'}
                  variant={'contained'}
                >
                  <div style={{ font: '500 16px Roboto' }}>Log In</div>
                </Button>
              </div>
            </div>
          )}
        </OnEvent>
        {showDocusignModal && (
          <DocusignModal
            onAccept={this.onDocusignAccept}
            onDecline={this.onDocusignDecline}
            docuRes={docuRes}
          />
        )}

        <DocusignNotificationModal
          ref={this.docusignNotificationModal}
          onClose={() => {}}
          docuRes={docuRes}
        />
      </Grid>
    )
  }
}

const Button = styled(MuiButton)`
  padding: 20px 30px;
  letter-spacing: 0.7px;
  min-width: 176px;
  border-radius: 8px !important;
  color: white;
  text-transform: none;
`

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
}))(SideCoverHOC(ContainerWithTitle(Login, 'BLAZE Login')))



// WEBPACK FOOTER //
// ./src/containers/Login.js